<template>
  <div class="container" v-if="isShow">
    <div class="head">
      <div class="title">
        <!-- <div class="text">{{assessInfo.assessName}}</div> -->
        <div class="text">{{ assessName }}</div>
        <!-- <div class="tit" @click="navTo()">
          <span>评分细则</span>
        </div>-->
        <!--评分细则隐藏-->
        <!-- -->
        <div class="flex-row  mt-8">
          <span> {{ areaName }}</span>
          <span class="ml-8">{{ quarterName }}</span>
        </div>

      </div>
      <div class="rules">
        <!-- <div class="branch" v-if="assessInfo.deduction>0">-{{assessInfo.deduction}}</div> -->
        
        <!-- 没有扣分记录 -->
        <!-- <div v-if="Number(assessInfo.deduction)==0" class="no-de">未扣分</div> -->
        <div v-if="Number(ls_deduction)==0" class="no-de">未扣分</div>
        <div v-else class="branch">-{{ ls_deduction }}</div>
        <!-- <div class="num">{{assessInfo.score}}/{{assessInfo.totalScore}}</div> -->
        <div class="num">{{ ls_score }}/{{ ls_sumScore }}</div>
      </div>
    </div>
    <template v-if="recordList && recordList.length > 0">
      <deducList :recordList="recordList" @navToDetail="navToDetail" ></deducList>
    </template>
    <!-- 没有扣分记录提示 -->
    <div v-else class="noData-bg">
      <nodata :noData="noData"></nodata>
    </div>
  </div>
</template>
<script>
import nodata from "../components/nodata"; // 没有数据
import deducList from "./components/deducList"; // 扣分列表
import api from "../../../service/modules/appraise";

import API from "../../../service/index";
import commonAPI from "../../../utils/common";

export default {
  components: {
    nodata,
    deducList,
  },

  data() {
    return {
      id: "1",
      assessInfo: {
        assessName: "综合监管模式完善运行情况",
        deduction: 0.3,
        score: 5.7,
        totalScore: 6.0,
      },
      assessName: this.$route.query.assessName,
      // assessName: "综合监管模式完善运行情况",
      deduction: 0,
      score: 0,
      noData: {
        title: "暂无数据",
      },
      recordList: [],
      asscessType: "",
      isShow: true,
      quarterName: this.$route.query.quarterName,
      pageType: this.$route.query.pageType,
      ls_deduction: 0,
      ls_sumScore: 0,
      ls_score: 0,
      temAuth: [],
      year: this.$route.query.year,
      quarter: this.$route.query.quarter,
      area: this.$route.query.area,
      areaName: this.$route.query.areaName,
    };
  },

  computed: {},

  watch: {},
  created() {
    const childAuth = commonAPI.getAuthorityList("ASSESS_SCORE");
    const notifyobj = commonAPI.getChileAuthList(childAuth, "MENU01");
    this.temAuth = notifyobj.children;
    this.getdeductionList(this.year, this.quarter, this.area);

    console.log("-----数据:", notifyobj);
  },
  methods: {
    getdeductionList(year, quarter, area) {
      //参数要从上个页面 带进来了
      API.getdeductionList({ year, quarter, area }).then((res) => {
        console.log("-----列表:", res);
        if (res.ret == 0) {
          //  this.recordList = res.data.list;
          this.ls_deduction = res.data ? (res.data.deduction / 100).toFixed(2) : 0;
          this.ls_sumScore = res.data ? (res.data.sumScore / 100).toFixed(1) : 0;
          this.ls_score = res.data ? (res.data.score / 100).toFixed(2) : 0;
          this.fixAuth(this.temAuth, res.data.list);
        }
      });
    },
    fixAuth(authList, list) {
      let fixList = [];
      if (list && list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          for (let j = 0; j < authList.length; j++) {
            if (list[i].monitorType === authList[j].assessType) {
              fixList.push(list[i]);
            }
          }
        }
        this.recordList = fixList;
      }
    },
    // 考核明细接口
    // getSubAssessScore() {
    //   this.isShow = false;
    //   api.getSubAssessScoreByArea({ id: this.appraiseId }).then(res => {
    //     if (res.ret === 0) {
    //       this.isShow = true;
    //       this.assessInfo = res.data.assessInfo;
    //       this.recordList = res.data.assessInfo.assessList;
    //       this.isShow = true;
    //     } else {
    //       this.$Message.error("res.data.msg");
    //     }
    //   });
    // },
    navTo() {
      this.$router.push({
        path: "/appraise/scoringList",
        query: {
          asscessType: this.assessInfo.asscessType,
        },
      });
    },
    // 跳转详情页
    navToDetail(subType, row, subName) {
      const params = commonAPI.getJsonLocal("a1a2a3");
      if (params) {
        commonAPI.removeJsonLocal("a1a2a3");
      }
      commonAPI.setJsonLocal("a1a2a3", {
        year: this.year,
        quarter: this.quarter,
        area: this.area,
        monitorType: row.monitorType,
        subName: row.monitorTypeCN,
      });
      console.log("------列表页选择跳转:", row.monitorType);
      this.$router.push({
        path: "/appraise/deduction_detail",
        query: {
          monitorType: row.monitorType,
          subName: row.monitorTypeCN,
          year: this.year,
          quarter: this.quarter,
          area: this.area,
        },
      });
    },
  },
  beforeDestroy() { },

  mounted() { },
};
</script>
<style scoped lang="less">
.container {
  min-height: 100vh;
  background: #fbfbfb;
  display: flex;
  flex-direction: column;
  position: relative;

  .noData-bg {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
  }

  .head {
    background: #fff;
    padding: 20px 12px;
    display: flex;
    justify-content: space-between;

    .title {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-right: 50px;

      .text {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 28px;
      }

      .tit {
        position: relative;
        display: flex;
        color: #999;
        font-size: 12px;
        margin-top: 12px;

        span {
          position: relative;
          padding-right: 16px;
        }

        span::after {
          content: "";
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 12px;
          height: 12px;
          background: url(../../../assets/image/t-right.png) no-repeat;
          background-size: 12px 12px;
        }
      }
    }

    .rules {
      display: flex;
      flex-direction: column;
      color: #666666;
      text-align: right;

      .num {
        color: #999999;
        font-size: 14px;
        margin-top: 8px;
      }

      .branch {
        height: 22px;
        font-size: 22px;
        // font-family: DIN-Medium, DIN;
        font-weight: 500;
        color: rgba(255, 77, 77, 1);
        line-height: 28px;
      }

      .no-de {
        min-width: 60px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(54, 179, 116, 1);
        line-height: 22px;
      }
    }
  }
}
</style>
